import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import classNames from 'classnames';
import Hidden from '@material-ui/core/Hidden';

import { _getDate, _todayDate } from '../../../utils/dateFormat'
import { fetchCall } from '../../../service/service_base';
import Loader from '../../../components/Loader/Loader';
import styles from '../../../../app/components/Header/SintesisMenu/sintesisMenu-jss';
import '../../../styles/normalize.scss';
import '../../../styles/layout/_base.scss';
import SliderCard from '../../../components/Sliders/SliderCard';
import SliderEditoriales from '../../../components/Sliders/SliderEditoriales';
import SliderCartones from '../../../components/Sliders/SliderCartones';
import SliderRadio from '../../../components/Sliders/SliderRadio';
import SliderEvent from '../../../components/Sliders/SliderEvent';
import Event from '../../../components/Event/Event';
import Portadas from '../../../components/Portadas/Portadas';
import CardButton from '../../../components/CardButton/CardButton';
import Banner from '../../../components/Banner';
import SliderTap from '../../../components/Sliders/SliderTap';
import PapperBlock from '../../../components/PapperBlock/PapperBlock';
import { ThemeContext } from '../../../utils/ThemeContext';
import TapMenu from '../../../components/Header/TapMenu';
import logotipo from '../../../../static/images/logotipo.svg'
import NotasTabs from '../../../components/NotesTabs';


class Preview extends React.Component {
  state = {
    isLoading: true,
    sections: [],
    contentSection: [],
    date: "",
    Header: null,
    Footer: null,
    selectedNotasTab: 0
  }
  _content = [];
  cardButton = []

  handleNotasTabChange = (event, newValue) => {
    this.setState({ selectedNotasTab: newValue });
  };

  componentDidMount() {
    var d;
    if (decodeURIComponent(this.props.match.params.date) == 0) {
      d = new Date()
      d.setHours(9, 0, 0)
    } else {
      const dateStr = decodeURIComponent(this.props.match.params.date);
      if (dateStr.includes('T')) {
        dateStr = dateStr.split('T')[0];
      }
      d = new Date(dateStr);
      d.setHours(d.getHours() + 12);
      if (isNaN(d.getTime())) {
        console.error('Fecha inválida:', dateStr);
        d = new Date();
      }
    }

    const params = new URLSearchParams(window.location.search);
    const tabParam = parseInt(params.get('tab')) || 0;
    this.setState({ selectedNotasTab: tabParam });

    this.setState(
      {
        date: d,
        isLoading: true
      }, () => {
        this._content = [];
        this.setState({
          isLoading: true,
          sections: [],
          contentSection: []
        }, () => {
          this.context.toggleTheme({ menu_description: decodeURIComponent(this.props.match.params.color) })
          if (this.props.match.params.id !== 0) {
            fetchCall("POST", "/synthesis/getsection", {
              menuId: this.props.match.params.id,
              portal: 'public'
            }).then(response => {
              this.setState(
                {
                  sections: response.data
                }, () => {
                  this._getPublishContent(this.state.sections, response.data.length, 0);
                }
              );
            }).catch(err => {
              console.log(err);
            });
          } else {
            alert("La síntesis en esta fecha no está disponible")
          }
        })

      }
    )
  }

  _getPublishContent = (section, tam, index) => {
    if (section.length === index) {
      if (this.state.contentSection.length > 0) {
        // let section = [];
        // section = this.state.sections.map(item => (
        //   {
        //     sec_icono: item.sec_icono,
        //     sec_iconoUrl: item.sec_iconoUrl,
        //     sec_id: item.sec_id,
        //     sec_name: item.sec_name,
        //     sec_orden: item.sec_orden,
        //     sec_tipo: item.sec_tipo,
        //     sec_color: item.sec_color,
        //     content: [...new Set(this.state.contentSection.filter(x => x.sec_id === item.sec_id))]
        //   }
        // ));

        this.setState({ isLoading: false })

      } else {
        this.setState({
          openNotification: true,
          messageNotification: "No se encontró una síntesis con esta fecha",
          typeNotification: 'warning',
          isLoading: false
        });
      }
    } else {
      fetchCall("POST", "/synthesis/getcontent", {
        sectionId: section[index].sec_id,
        isPublish: parseInt(this.props.match.params.ps) === 0 ? 0 : 1,
        idPublish: parseInt(this.props.match.params.ps)
      }).then(response => {
        if (response) {
          if (response.status === 200) {
            if (response.data != null) {
              response.data.map(item => {
                item.publish_date = null;
                item.cont_attachment = item.cont_attachmentKey;
                this._content.push(item);
              });
              if (response.data.length > 0 && ["Header", "Footer"].includes(section[index].sec_tipo)) {
                response.data[0].sec_color = section[index].sec_color;
                this.setState({ [section[index].sec_tipo]: response.data[0] })
              }
              this.setState({
                contentSection: this._content
              }, () => {
                this._getPublishContent(section, tam, index + 1)
              });
            }
          }
        } else {
          this._getPublishContent(section, tam, index + 1)
        }
      }).catch(err => {
        console.log("error contenido", err)
      });
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Grid container className={classNames(classes.root,classes.pb0)}>
          <Grid item xs={12}>
            {
              this.state.Header && <div className={classes.headerWeb} style={{ padding: "8px", backgroundColor: this.state.Header && this.state.Header.sec_color, color: '#FFFFFF' }}>
                <Hidden xsDown>
                  <img src={this.state.Header.cont_imagePath} alt="Header" className={classes.logo} />
                </Hidden>
                <Hidden smUp>
                  <img src={this.state.Header.cont_imagePath} alt="Header" className={classes.logoM} />
                </Hidden>
                <div style={{display:"flex",flexDirection:"column", justifyContent:"space-between",alignItems:"flex-end"}}>
                  <a href="#web" className={classNames(classes.linkHeader)} style={{ color: decodeURIComponent(this.props.match.params.color) }}>
                    {decodeURIComponent(this.props.match.params.name)}
                  </a>
                  <span style={{fontSize:14}}>Publicado el {this.state.date === 0 ? _getDate() : _getDate(this.state.date)}</span>
                </div>
              </div>
            }
            {!this.state.Header && <div className={classes.headerWeb}  style={{ padding: "5px" }}>
              <Hidden xsDown>
                <img src="/public/Synthesis/Icons/logo_default_black.jpg" alt="header" className={classes.logo} />
              </Hidden>
              <Hidden smUp>
                <img src="" alt="header" className={classes.logoM} />
              </Hidden>
              <span style={{fontSize:14}}>  {this.state.date === 0 ? _getDate() : _getDate(this.state.date)}</span>
            </div>}
          </Grid>
          <Hidden xsUp>
            <Grid item xs={12}>
              <Grid
                container
                className={classes.demo}
                alignItems="center"
                direction="row"
                justify="center"
              >
                <Grid item align="center">
                  <a href="#web" className={classNames(classes.link, classes.active)} style={{ color: decodeURIComponent(this.props.match.params.color) }}>
                    {decodeURIComponent(this.props.match.params.name)}
                  </a>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} align="center" style={{fontSize:14,marginBottom:10}}>
              <span>{this.state.date === 0 ? _getDate() : _getDate(this.state.date)}</span>
            </Grid>
          </Hidden>
        </Grid>

        {/* Sección de Portadas */}
        {
          !this.state.isLoading && this.state.sections
            .filter(item => item.sec_tipo === "Portada")
            .map((item, key) => {
              item.content = this.state.contentSection.filter(x => x.sec_id === item.sec_id);
              return (
                <div id={item.sec_name ? item.sec_name.toString().trim() : ""} style={{ display: item.content.length > 0 ? 'block' : 'none' }} key={key}>
                  <div style={{ backgroundColor: item.sec_color }}>
                    <Portadas section={item} idMenuSelected={this.props.match.params.id} isSearching />
                  </div>
                </div>
              );
            })
        }

        {/* <TapMenu state={{}} availableSection={this.state.sections} /> */}

        {/* Sección de Notas con Tabs */}
        {
          !this.state.isLoading && (() => {
            // Obtener sección Relevante
            const relevanteSection = this.state.sections.find(item => item.sec_tipo === "Relevante");
            if (relevanteSection) {
              relevanteSection.content = this.state.contentSection.filter(x => x.sec_id === relevanteSection.sec_id);
            }
            
            // Obtener secciones de Notas
            const notasSections = this.state.sections.filter(item => item.sec_tipo === "Notas");
            notasSections.forEach(item => {
              item.content = this.state.contentSection.filter(x => x.sec_id === item.sec_id);
            });
            const notasWithContent = notasSections.filter(item => item.content.length > 0);
            
            // Obtener secciones de NotasColumnas
            const notasColumnasSections = this.state.sections.filter(item => item.sec_tipo === "NotasColumnas");
            notasColumnasSections.forEach(item => {
              item.content = this.state.contentSection.filter(x => x.sec_id === item.sec_id);
            });
            const notasColumnasWithContent = notasColumnasSections.filter(item => item.content.length > 0);
            
            // Combinar Relevante (si existe y tiene contenido) como primera tab + Notas + NotasColumnas
            const tabSections = [
              ...(relevanteSection && relevanteSection.content.length > 0 ? [relevanteSection] : []),
              ...notasWithContent,
              ...notasColumnasWithContent
            ];
            
            if (tabSections.length === 0) return null;
            return (
              <NotasTabs 
                tabSections={tabSections}
                idMenuSelected={parseInt(this.props.match.params.id)}
                classes={{
                  tabTextWhite: classes.tabTextWhite
                }}
                isSearching={true}
                selectedTab={this.state.selectedNotasTab}
                onTabChange={this.handleNotasTabChange} 
              />
            );
          })()
        }

        {
          this.state.isLoading ? <Loader text="Cargando vista previa..." /> :
            this.state.sections.map((item, key) => {
              item.content = this.state.contentSection.filter(x => x.sec_id === item.sec_id);
              if (item.sec_tipo === "NotasEditoriales" || item.sec_tipo === "Card"|| item.sec_tipo === "EditorialCard") {
                if (item.content.length > 0) {
                  this.cardButton = [...this.cardButton, ...item.content]
                }
                if (item.sec_tipo === "Card"|| item.sec_tipo === "EditorialCard") {
                  item.content = this.cardButton;
                  item.sec_tipo = "EditorialCard";
                  this.cardButton=[]
                }
              }
              switch (item.sec_tipo) {
                case "Banner":
                  return <Banner section={item} idMenuSelected={parseInt(this.props.match.params.id)} key={key} isSearching/>
                case "Relevante":
                  return null;
                case "Portada":
                  return null;
                case "Notas":
                  return null;
                case "NotasColumnas":
                  return null;
                case "EditorialCard":
                  return (
                    <div id="EditorialCard" key={key}>
                      <div style={{ backgroundColor: item.sec_color, paddingTop: 25 }}>
                        <div className={classNames('container', classes.paddingContent, classes.WrapperButton)}>
                          <CardButton section={item} idMenuSelected={parseInt(this.props.match.params.id)} key={key} isSearching/>
                        </div>
                      </div>
                    </div>
                  )

                case "Radio":
                  return (
                    <div id={item.sec_name ? item.sec_name.toString().trim() : ""} style={{ display: item.content.length > 0 ? 'block' : 'none' }} key={key}>
                      <div style={{ backgroundColor: item.sec_color, paddingTop: 25 }}>
                        <PapperBlock secName={item.sec_name.toString().trim()} img={item.sec_icono} isVisible={item.content.length > 0} title={item.sec_name} colorTitle={item.sec_color} colorMode desc="" >
                          <SliderRadio section={item} idMenuSelected={parseInt(this.props.match.params.id)} isSearching/>
                        </PapperBlock>
                      </div></div>
                  )
                case "Evento":
                  return (
                    <div id={item.sec_name ? item.sec_name.toString().trim() : ""} style={{ display: item.content.length > 0 ? 'block' : 'none' }} key={key}>
                      <div style={{ backgroundColor: item.sec_color, paddingTop: 25 }}>
                        <PapperBlock secName={item.sec_name.toString().trim()} img={item.sec_icono} isVisible={item.content.length > 0} title={item.sec_name} colorTitle={item.sec_color} colorMode desc="" >
                          <SliderEvent section={item} idMenuSelected={parseInt(this.props.match.params.id)} isSearching/>
                          {/* <Event section={item} idMenuSelected={this.props.match.params.id} isSearching /> */}
                        </PapperBlock>
                      </div></div>
                  )
                default:
                  return ""
              }
            })
        }

        <div className={classNames("Footer", classes.mt5)}  style={{ backgroundColor: this.state.Footer && this.state.Footer.sec_color }}>
          {false && <div className={classNames('sintesisContent',classes.bgAlpha30)}>
            <a href={`#web`}>{decodeURIComponent(this.props.match.params.name)}</a>
          </div>}
          <div className={classNames("subMenu", classes.bgAlpha15)}>
            {
              this.state.sections.map((item, index) => {
                if (!["Header", "Banner", "Footer"].includes(item.sec_tipo))
                  if (parseInt(item.sec_totalContent) > 0) {
                    if (item.sec_tipo === "NotasEditoriales" || item.sec_tipo === "Card" || item.sec_tipo === "EditorialCard") {
                      item.sec_link = "EditorialCard"
                    }else{
                      item.sec_link = item.sec_name
                    }
                    return (
                      <a href={`#${item.sec_link}`} key={index.toString()}>
                        {item.sec_name}
                      </a>
                    )
                  }
                  else
                    return null
              })
            }
            {!this.state.Footer && <div className="copy">
              <img src={logotipo} alt="Televisa" title="Televisa" className="logo" />
              <div className="textCopy" style={{ color: "white" }}>
                Derechos Reservados @ Televisa S.A. de C.V. TELEVISA y el logotipo de TELEVISA son marcas registradas
              </div>
            </div>}
          </div>
          {
            this.state.Footer && <div className='customFooter' style={{ background: this.state.Footer && this.state.Footer.sec_color }}><div className="copy">
              <img src={this.state.Footer.cont_imagePath} alt="Televisa" title="Televisa" className="logo" />
              <div className="textCopy">
                <span style={{ color: this.state.Footer && (this.state.Footer.sec_color.includes("#") && this.state.Footer.sec_color.toLowerCase() != "#ffffff") ? "white" : "" }}
                  dangerouslySetInnerHTML={{ __html: `${this.state.Footer.cont_description}` }} />
              </div>
            </div></div>
          }
        </div>

      </React.Fragment>
    );
  }
}
Preview.contextType = ThemeContext;
export default withStyles(styles)(Preview);
